import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./index.css";
import { RoleProvider } from "./Components/RoleContext";
import Layout from "./Layout";
import Dashboard from "./Pages/Dashboard";
import HotspotMapping from "./Pages/HotspotMapping";
import { Navigate } from "react-router-dom";
import LoginPage from "./Pages/Login";
import Home from "./Pages/Home";
import Weather from "./Pages/Weather";
import RiskPrediction from "./Pages/RiskPrediction";
import ModelTraining from "./Pages/ModelTraining";

export default function App() {
  return (
    <RoleProvider>
      <Router>
        <Routes>
          {/* when you open localhost: it should go to login page */}
          <Route path="/" element={<Navigate to="/login" replace />} />

          {/* login route */}
          <Route path="/login" element={<LoginPage />} />

          {/* protected app routes under Layout */}
          <Route element={<Layout />}>
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="hotspot" element={<HotspotMapping />} />
            <Route path="weather" element={<Weather />} />
            <Route path="risk-prediction" element={<RiskPrediction />} />
            <Route path="model-training" element={<ModelTraining />} />
            <Route path="region-select" element={<Home />} />
            <Route path="region-select/:state" element={<Home />} />
            <Route path="region-select/:state/:zone" element={<Home />} />
            <Route
              path="region-select/:state/:zone/:woreda"
              element={<Home />}
            />
            <Route
              path="region-select/:state/:zone/:woreda/:kebele"
              element={<Home />}
            />
          </Route>

          {/* fallback for unknown routes */}
          {/* <Route path="*" element={<Navigate to="/login" replace />} /> */}
        </Routes>
      </Router>
    </RoleProvider>
  );
}
